import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'border-corner-rounded', 'BorderCornerRounded', [["path",{"d":"M4 20v-10a6 6 0 0 1 6 -6h10"}]]);